export default [
  {
    path: '/activity-center',
    name: 'ActivityCenter',
    component: () => import('@/views/activity/index.vue'),
    meta: {
      auth: true,
      title: '活动中心',
      keepAlive: false,
      headerTheme: 'dark'
    }
  },
  {
    path: '/activity-records',
    name: 'ActivityRecords',
    component: () => import('@/views/activity/records.vue'),
    meta: {
      auth: true,
      title: '互助记录',
      keepAlive: false,
      headerTheme: 'dark'
    }
  }
]
